import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import ConfigAction from '../actions/ConfigAction';
import HomeAction from '../actions/HomeAction';
import { HomeSelector } from '../reducers/HomeReducer';
import { ConfigSelector } from '../reducers/ConfigReducer';
import Home from '../../components/home/Home/Home';
import PlansAction from '../actions/PlansAction';

const mapStateToProps = state => ({
  isUnderMaintenance: ConfigSelector.isUnderMaintenance(state),
  isAddressSelected: HomeSelector.getIsAddressSelected(state)
});

const mapDispatchToProps = dispatch =>
  bindActionCreators({
    fetchAddress: HomeAction.fetchAddress,
    storeStaticConfig: ConfigAction.storeStaticConfig,
    setSelectedPlan: PlansAction.setSelectedPlan,
    fetchOrderInfo: HomeAction.fetchOrderInfo
  }, dispatch);

const HomeContainer = connect(mapStateToProps, mapDispatchToProps)(Home);

export default HomeContainer;



/** WEBPACK FOOTER **
 ** ./src/redux/containers/HomeContainer.js
 **/